
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FeatureManagerService } from '@Services';
import { FeatureToggle, MrsColor } from 'app/enums';
import moment from 'moment';
import { SubSink } from 'subsink';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { NgIf } from '@angular/common';
import { MrsBtnTertiaryComponent } from '../../../../../../shared/components/mrs-buttons/mrs-btn-tertiary/mrs-btn-tertiary.component';


@Component({
    selector: 'follow-up-dialog',
    templateUrl: './follow-up-dialog.component.html',
    styleUrls: ['./follow-up-dialog.component.scss'],
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, RxReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgIf, MatError, MatDialogActions, MrsBtnTertiaryComponent]
})
export default class FollowUpDialog implements OnInit, OnDestroy{

    followUpformGroup: FormGroup;
    buttonColor = MrsColor.UIBlue;
    title: string;
    isEdit = false;
    msg: string;
    followUp: string;
    readOnly = false;
    minDate: Date;
    maxDate: Date;
    clientId: string;

    subs = new SubSink();
    
    constructor(
        public dialogRef: MatDialogRef<FollowUpDialog>,
        protected featureManagerService: FeatureManagerService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _fb: FormBuilder
    ) {
        this.title = data.title;
        this.msg = data.msg;
        this.followUp = data.followUp;
        this.clientId = data.clientId;
        this.followUpformGroup = _fb.group({ 'follow-up': [this.followUp] });

    }

    //#region Lifecycle

    ngOnInit() {
        this.subscribeToFeatureToggles();

    }

    //#endregion
    //#region Handlers

    subscribeToFeatureToggles() {
        this.subs.add(this.featureManagerService.isEnabled(FeatureToggle.UWWorkbenchRequirementsFollowupDateAllowToday, this.clientId).subscribe(isEnabled => {
            if (isEnabled) {                
                this.minDate = moment().add(0, 'day').startOf('day').toDate();
                this.maxDate = moment().add(12, 'month').startOf('day').toDate();
            }else{                
                this.minDate = moment().add(1, 'day').startOf('day').toDate();
                this.maxDate = moment().add(12, 'month').startOf('day').toDate();
            }
        }));

    }

    updateFollowUp(): void {
        this.dialogRef.close({
            "followUp": this.followUpformGroup.get('follow-up').value
        });
    }

    cancel(): void {
        this.dialogRef.close();
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    //#endregion

}
